import { render, staticRenderFns } from "./SelectTemplateModal.vue?vue&type=template&id=6be0e713&"
import script from "./SelectTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./SelectTemplateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports